import { createContext as e, use as o } from "react";
const s = e({
  mobileDisclose: {
    isOpen: !1,
    onOpen: () => {
    },
    onClose: () => {
    }
  }
}), n = () => o(s);
export {
  s as S,
  n as u
};
